import { DialogClose, DialogContent, openDialog, type DialogComponentProps } from '@/kit/dialog';
import { Icon } from '@/kit/Icon';

export interface ImageViewerData {
  /** Anything an <img> can show: a data: URL for a file not sent yet, a blob: URL for a saved attachment. */
  src: string;
  fileName: string;
}

/** An attachment image shown full size over the page, with its name and a close button (Esc/backdrop close too). */
export function ApplicationTestingImageViewer({ data }: DialogComponentProps<ImageViewerData>) {
  if (!data) return null;
  return (
    <div className="mat-dialog-wrapper application-testing-image-viewer">
      <DialogContent>
        <div className="application-testing-image-viewer-header">
          <span className="application-testing-image-viewer-name" title={data.fileName}>
            {data.fileName}
          </span>
          <DialogClose aria-label="Close image">
            <Icon name="close" className="close" />
          </DialogClose>
        </div>
        <img src={data.src} alt={data.fileName} className="application-testing-image-viewer-image" />
      </DialogContent>
    </div>
  );
}

/** Opens an image in the viewer. Used both for files waiting under the comment box and for saved attachments. */
export function viewImage(src: string, fileName: string) {
  openDialog<ImageViewerData>(ApplicationTestingImageViewer, {
    data: { src, fileName },
    maxWidth: '90vw',
    panelClass: 'application-testing-image-viewer-panel',
  });
}
